import React, { useRef } from 'react';
import 'react-slideshow-image/dist/styles.css';
import "../slideshow.css";
import { Fade } from 'react-slideshow-image';


function Slide({
  alwaysShowControls = false,
  images,
  title,
  imageFit = "contain",
  navPosition = "bottom",
  showHeader = true,
}) {
  const slideshowRef = useRef(null);
  const slideshowImages = Array.isArray(images) ? images.filter(Boolean) : [];
  const hasImages = slideshowImages.length > 0;
  const canAdvance = slideshowImages.length > 1;
  const showControls = canAdvance || (alwaysShowControls && hasImages);

  const slideProps = {
    arrows: false,
    autoplay: false,
    canSwipe: canAdvance,
    duration: 5000,
    infinite: canAdvance,
    indicators: false,
    pauseOnHover: true,
    transitionDuration: 320,
  };

  return (
    <article className="slideshow-panel">
      {showHeader ? (
        <div className="text-center slideshow-panel__header">
          <h4 className="fw-bolder">{title}</h4>
        </div>
      ) : null}
      <div className={`slideshow slideshow--nav-${navPosition}`}>
        {hasImages ? (
          <>
            <Fade ref={slideshowRef} {...slideProps}>
              {slideshowImages.map((image, index) => (
                <div className="slideshow__slide" key={`${title}-${index}`}>
                  <img
                    src={image}
                    alt={`${title} ${index + 1}`}
                    className={`slideshow__image slideshow__image--${imageFit}`}
                  />
                </div>
              ))}
            </Fade>
            {showControls ? (
              <div className="slideshow__manual-controls">
                <button
                  className="slideshow-nav prev"
                  aria-label={`Show previous photo for ${title}`}
                  disabled={!canAdvance}
                  onClick={() => slideshowRef.current?.goBack()}
                  type="button"
                >
                  ❮
                </button>
                <button
                  className="slideshow-nav next"
                  aria-label={`Show next photo for ${title}`}
                  disabled={!canAdvance}
                  onClick={() => slideshowRef.current?.goNext()}
                  type="button"
                >
                  ❯
                </button>
              </div>
            ) : null}
          </>
        ) : (
          <div className="slideshow__placeholder">
            <p>Photos coming soon</p>
            {alwaysShowControls ? (
              <div className="slideshow__placeholder-controls" aria-hidden="true">
                <button className="slideshow-nav prev disabled" disabled type="button">
                  ❮
                </button>
                <button className="slideshow-nav next disabled" disabled type="button">
                  ❯
                </button>
              </div>
            ) : null}
          </div>
        )}
      </div>
    </article>
  );
}

export default Slide;
